export default function decodeJWT(token) {
    try {
      const base64Url = token.split('.')[1]; // Get the payload part
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  
      // Decode Base64
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map(c => `%${('00' + c.charCodeAt(0).toString(16)).slice(-2)}`)
          .join('')
      );
  
      return JSON.parse(jsonPayload);
    } catch (e) {
      console.error('Invalid JWT:', e);
      return null;
    }
}